export const CLOSE_MANAGE_COOKIES = 'CLOSE_MANAGE_COOKIES';
export const OPEN_MANAGE_COOKIES = 'OPEN_MANAGE_COOKIES';
export const GET_HTML_DOMAINS = 'GET_HTML_DOMAINS';

export function openManageCookies() {
  return {
    type: OPEN_MANAGE_COOKIES,
  };
}

export function closeManageCookies() {
  return {
    type: CLOSE_MANAGE_COOKIES,
  };
}

/**
 * Get HTML domains function.
 * @function getHtmlDomains
 * @returns {Object} Get HTML domains action.
 */
export function getHtmlDomains() {
  return {
    type: GET_HTML_DOMAINS,
    request: {
      op: 'get',
      path: '/@html-domains',
    },
  };
}
